/* eslint-disable */
import Vue from 'vue'
import CheckSealCom from './checkSeal.vue'

// 通过Vue.extend将组件包装成一个子类
const CheckSealConstructor = Vue.extend(CheckSealCom)

let checkSeal

CheckSealConstructor.prototype.close = function() {
  if (checkSeal) {
    checkSeal = undefined
  }
  // 先将组件隐藏
  this.show = false
  // 移除挂载的dom元素
  if (this.$el && this.$el.parentNode) {
    this.$el.parentNode.removeChild(this.$el)
  }
  // 调用组件的$destroy方法进行组件销毁
  this.$destroy()
}

const CheckSeal = (options = {}) => {
  // 如果组件已渲染，则返回即可
  // 要挂载的元素
  const parent = document.body
  // 通过构造函数初始化组件 相当于 new Vue()
  const instance = new CheckSealConstructor({
    el: document.createElement('div')
  })
  parent.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.show = true
  })
  checkSeal = instance
  return instance
}

export default CheckSeal
export { checkSeal }